var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "information",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.067,
    height: 28.067,
    viewBox: "0 0 28.067 28.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12460",
    "data-name": "Path 12460",
    d: "M14.033,0A14.033,14.033,0,1,0,28.067,14.033,14.026,14.026,0,0,0,14.033,0Zm0,26.2A12.162,12.162,0,1,1,26.2,14.033,12.176,12.176,0,0,1,14.033,26.2Z",
    transform: "translate(0)",
    fill: "#c7e2e4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196",
    transform: "translate(13.098 11.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12461",
    "data-name": "Path 12461",
    d: "M239.866,209.777a.936.936,0,0,0-.936.936V218.6a.936.936,0,1,0,1.871,0v-7.892A.936.936,0,0,0,239.866,209.777Z",
    transform: "translate(-238.93 -209.777)",
    fill: "#c7e2e4"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198",
    transform: "translate(12.162 6.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12462",
    "data-name": "Path 12462",
    d: "M223.738,124.122a1.871,1.871,0,1,0,1.871,1.871A1.873,1.873,0,0,0,223.738,124.122Z",
    transform: "translate(-221.867 -124.122)",
    fill: "#c7e2e4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.668205038976ae99fb8be7f29d3ab3e5.svg";
export { ForwardRef as ReactComponent };